interface Props {
  className?: string;
}

export function Skeleton({ className }: Props) {
  return (
    <span
      aria-hidden="true"
      className={'inline-block animate-pulse rounded-md bg-line/80 ' + (className ?? 'h-4 w-24')}
    />
  );
}

export function SkeletonText({ lines = 3 }: { lines?: number }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: lines }, (_, i) => (
        <Skeleton key={i} className={'h-3 ' + (i === lines - 1 ? 'w-2/3' : 'w-full') + ' block'} />
      ))}
    </div>
  );
}
